import React from 'react'
import {FormikProps} from 'formik'
import {ModeleReferentielFournisseurPOT} from '../../../../components/Models'
import {TextInput} from '../../../../components/inputs/TextInput'

type Props = {
  formik: FormikProps<ModeleReferentielFournisseurPOT>
  isInModal: boolean
  nom: any
  setNom: any
  existName: any
  verifEnCours: any
  isRequis: any
  onExistName?: any
}

const FournisseurPOTFields: React.FC<Props> = (
  {
    formik,
    isInModal,
    nom = null,
    setNom = null,
    existName = null,
    verifEnCours = null,
    isRequis = false,
    onExistName
  }) => {
  return (
    <>
      <div className='row mb-6'>
        <label className='col-lg-4 col-form-label required fw-bold fs-6'>Nom</label>
        <div className='col-lg-8'>
          <div className='row'>
            <div className={`${isInModal ? 'col-lg-12' : 'col-lg-6'} fv-row`}>
              <input
                name={'nom'}
                placeholder={'Nom'}
                type={'text'}
                className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                // formik={formik}
                onChange={(e) => {
                  setNom(e.target.value)
                  formik.setFieldValue('nom', e.target.value)
                  onExistName()
                }}
                value={nom}
              />
              {isRequis && <span style={{color: 'red'}}>Ce champs est requis.</span>}
              {existName && <span style={{color: 'red'}}>Ce fournisseur existe déjà.</span>}
              {verifEnCours && <span style={{color: 'blue'}}>Vérification...</span>}
            </div>
          </div>
        </div>
      </div>

      <div className='row mb-6'>
        <label className='col-lg-4 col-form-label fw-bold fs-6'>Lien ou autres</label>
        <div className='col-lg-8'>
          <div className='row'>
            <div className={`${isInModal ? 'col-lg-12' : 'col-lg-6'} fv-row`}>
              <TextInput
                fieldName={'lien'}
                inputPlaceholder={'Lien ou autres'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                formik={formik}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FournisseurPOTFields
